<template>
    <el-container id="nhMainPhone">
        <div class="topButton">
            <el-button class="custom-el-button" type="primary" size="medium" @click="showHomePage">
                <i class="el-icon-s-home"></i> 首页
            </el-button>
        </div>

        <el-main class="phoneMainBox" style="overflow-y:hidden">
            <el-tabs v-model="activeName" @tab-click="handleClick" :tab-position="tabPosition">
                <el-tab-pane v-if="flag.info" name="first">
                    <span slot="label" class="tabTitleBox"><i class="el-icon-user"></i> 实习信息</span>
                    <div class="phoneMain">
                        <div class="phoneTitle">
                            <h3><i class="el-icon-user"></i> 实习信息</h3>
                        </div>
                        <div v-if="flag.one" :style="{'height': mainHeight+'px'}">
                            <infoMobile :div-height="mainHeight"/>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane v-if="flag.summary" name="second">
                    <span slot="label" class="tabTitleBox"><i class="el-icon-notebook-1"></i> 实习周记</span>
                    <div class="phoneMain">
                        <div class="phoneTitle">
                            <h3><i class="el-icon-notebook-1"></i> 实习周记</h3>
                        </div>
                        <div v-if="flag.two" :style="{'height': mainHeight+'px'}">
                            <summaryMobile :div-height="mainHeight"/>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane v-if="flag.guidance" name="third">
                    <span slot="label" class="tabTitleBox"><i class="el-icon-data-analysis"></i> 现场指导</span>
                    <div class="phoneMain">
                        <div class="phoneTitle">
                            <h3><i class="el-icon-data-analysis"></i> 现场指导</h3>
                        </div>
                        <div v-if="flag.thr" :style="{'height': mainHeight+'px'}">
                            <reportMobile :div-height="mainHeight"/>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane v-if="flag.apply" name="four">
                    <span slot="label" class="tabTitleBox"><i class="el-icon-phone-outline"></i> 自主联系</span>
                    <div class="phoneMain">
                        <div class="phoneTitle">
                            <h3><i class="el-icon-phone-outline"></i> 自主联系申请</h3>
                        </div>
                        <div v-if="flag.fou" :style="{'height': mainHeight+'px'}">
                            <autonomouslyApplyMobile :div-height="mainHeight"/>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane v-if="flag.change" name="five">
                    <span slot="label" class="tabTitleBox"><i class="el-icon-refresh"></i> 实习变更</span>
                    <div class="phoneMain">
                        <div class="phoneTitle">
                            <h3><i class="el-icon-refresh"></i> 实习变更申请</h3>
                        </div>
                        <div v-if="flag.fiv" :style="{'height': mainHeight+'px'}">
                            <practiceChangeMobile :div-height="mainHeight"/>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-main>
    </el-container>
</template>
<script>
import {confirmBox} from 'utils/message'; //对话框组件
import {} from 'utils/validate'; //验证组件
import {ajax} from 'utils/index';
import {globalConfig} from "../../../static/config";
import infoMobile from "./practice/infoMobile";
import summaryMobile from "../mobile/practice/summaryMobile";
import reportMobile from "../mobile/practice/reportMobile";
import autonomouslyApplyMobile from "./practice/autonomouslyApplyMobile";
import practiceChangeMobile from "./practice/practiceChangeMobile";

export default {
    components: {
        infoMobile,
        summaryMobile,
        reportMobile,
        autonomouslyApplyMobile,
        practiceChangeMobile
    },
    data() {
        return {
            activeName: 'first',
            tabPosition: 'bottom',

            user: {
                userName: '',
                userCode: '',
                userRoles: []
            },
            flag: {
                info: false,
                summary: false,
                guidance: false,
                apply: false,
                change: false,
                one:true,
                two:true,
                thr:true,
                fou:true,
                fiv:true,
            },
            mainHeight:500,
        }
    },
    mounted() {
        this.userInfo()

        this.$nextTick().then(() => {
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
            this.mainHeight = window.innerHeight- 140;
            // 监听窗口大小变化
            let self = this;
            window.onresize = function () {
                self.mainHeight = window.innerHeight- 140;
            };
        });

    },
    methods: {
        showHomePage() {
            this.$router.push('/m/wx/home');
        },
        userInfo() {
            this.$api.system.basic.userInfo({})
                .then((res) => {
                    this.user.userCode = res.data.data.phone;
                    for (let roleCode in res.data.data.roles) {
                        if (roleCode === globalConfig.auth.admin || roleCode === globalConfig.auth.jwy_sx || roleCode === globalConfig.auth.fdy || roleCode === globalConfig.auth.sx_xbgly || roleCode === globalConfig.auth.sx_zyzdjs) {
                            this.user.userRoles.push(roleCode)
                        }
                    }

                    // this.user.userCode = '096136'
                    // this.user.userRoles = []
                    // this.user.userRoles.push(globalConfig.auth.jwy_sx)

                    if (this.user.userRoles.indexOf(globalConfig.auth.admin) > -1 || this.user.userRoles.indexOf(globalConfig.auth.jwy_sx) > -1) {
                        this.flag.info = true;
                        this.flag.summary = true;
                        this.flag.guidance = true;
                        this.flag.apply = true;
                        this.flag.change = true;
                        document.documentElement.style.setProperty('--width1', '80%');
                    }

                    if (this.user.userRoles.indexOf(globalConfig.auth.fdy) > -1) {
                        this.flag.info = true;
                        this.flag.summary = true;
                        this.flag.guidance = true;
                        this.flag.apply = true;
                        this.flag.change = true;
                        document.documentElement.style.setProperty('--width1', '80%');
                    }

                    if (this.user.userRoles.indexOf(globalConfig.auth.sx_xbgly) > -1) {
                        this.flag.info = true;
                        this.flag.apply = true;
                        this.flag.change = true;
                        document.documentElement.style.setProperty('--width1', '133%');
                    }

                    if (this.user.userRoles.indexOf(globalConfig.auth.sx_zyzdjs) > -1) {
                        this.flag.info = true;
                        this.flag.summary = true;
                        this.flag.guidance = true;
                        document.documentElement.style.setProperty('--width1', '133%');
                    }

                }).catch((err) => {
                console.log(err);
            });
        },
        handleClick(tab, event) {
            this.flag.one = false;
            this.flag.two = false;
            this.flag.thr = false;
            this.flag.fou = false;
            this.flag.fiv = false;
            if(tab.index === '0'){
                this.flag.one = true;
            }
            if(tab.index === '1'){
                this.flag.two = true;
            }
            if(tab.index === '2'){
                this.flag.thr = true;
            }
            if(tab.index === '3'){
                this.flag.fou = true;
            }
            if(tab.index === '4'){
                this.flag.fiv = true;
            }

        }
    }
}
</script>
<style src="styles/mobile.css"></style>

<style>
:root {
    --width1: 80%;
}

#nhMainPhone {
    width: 100%;
    height: 100vh;
}

/*********************** 中心 ***********************/
#nhMainPhone .phoneMainBox {
    background-color: #f8f8f8;
    /* overflow-y: auto; */
    padding: 0 !important;
    position: relative;
}

#nhMainPhone .phoneMain {
    background-color: #fff;
    border-radius: 5px;
    margin: 10px 0;
}

/* 切换tab */
#nhMainPhone .phoneMainBox .el-tabs__header {
    position: fixed;
    bottom: 0;
    height: 60px;
    width: 100%;
    background-color: #f8f8f8;
    z-index: 2;
}

/* 导航 */
#nhMainPhone .phoneMainBox .el-tabs__header .el-tabs__nav {
    width: var(--width1);
}

#nhMainPhone .phoneMainBox .el-tabs__header .el-icon-arrow-left {
    display: none;
}

#nhMainPhone .phoneMainBox .el-tabs__header .el-icon-arrow-right {
    display: none;
}

#nhMainPhone .phoneMainBox .el-tabs__header .el-tabs__active-bar {
    /*width: 20%;*/
}

#nhMainPhone .phoneMainBox .el-tabs__header .el-tabs__item {
    height: 60px;
    line-height: 60px;
    width: 25%;
    text-align: center;
    padding: 0;
}

#nhMainPhone .phoneMainBox .tabTitleBox {
    font-size: 0.9em;
    text-align: center;
    height: 100%;
    width: 100%;
    display: block;
    float: left;
    line-height: 20px;
}

#nhMainPhone .phoneMainBox .tabTitleBox i,
#nhMainPhone .phoneMainBox .tabTitleBox span {
    display: block;
}

#nhMainPhone .phoneMainBox .tabTitleBox i {
    font-size: 25px;
    padding: 8px 0 5px 0;
}

#nhMainPhone .phoneMainBox .el-tabs__content {
    padding: 10px;
    margin-bottom: 60px;
}

/* 标题 */
#nhMainPhone .phoneTitle {
    border-bottom: 3px #6da1d6 solid;
    position: relative;
}

#nhMainPhone .phoneTitle h3 {
    display: inline-block;
    margin: 20px 10px 15px 10px;
    color: #0055AA;
}

#nhMainPhone .phoneTitle.twoTitle {
    display: inline-block;
    padding: 0 5px;
    border-bottom: 4px #6da1d6 double;
}

#nhMainPhone .phoneTitle.twoTitle h3 {
    margin: 20px 10px 5px 10px;
    color: #000;
}

/* 轮播图 */
#nhMainPhone .phoneMainBox .el-carousel__container {
    margin-top: 10px;
    height: 180px;
}

#nhMainPhone .phoneMainBox .el-carousel__item {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 4% 30% 0 20px;
    color: #fff;
    border-radius: 8px;
}

#nhMainPhone .phoneMainBox .el-carousel__item h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4; /*行数*/
    -webkit-box-orient: vertical;
}

/* 按钮组 */
#nhMainPhone .phoneMain .iconBtnGroup {
    padding: 10px;
    overflow: overlay;
    margin: 10px 0;
}

#nhMainPhone .phoneMain .iconBtnGroup .iconBtn {
    width: 33.3%;
    display: inline-block;
    float: left;
    text-align: center;
    margin: 5px 0;
}

#nhMainPhone .phoneMain .iconBtnGroup .iconBtn:nth-child(odd) i {
    color: #67c23a;
    background: #f0f9eb;
    border-color: #c2e7b0;
}

#nhMainPhone .phoneMain .iconBtnGroup .iconBtn:nth-child(even) i {
    color: #e6a23c;
    background: #fdf6ec;
    border-color: #f5dab1;
}

#nhMainPhone .phoneMain .iconBtnGroup i {
    /* border: 1px red solid; */
    display: inline-block;
    padding: 13px;
    border-radius: 10px;
    font-size: 2em;
    color: #fff;
}

#nhMainPhone .phoneMain .iconBtnGroup p {
    margin: 0;
    padding: 8px 0;
    font-size: 14px;
}

/* 卡片 */
#nhMainPhone .phoneMain .phoneListCard {
    /* border: 1px red solid; */
    padding: 20px;
}

#nhMainPhone .phoneMain .phoneListCard .listCard {
    box-shadow: 0 0 10px #e7e7e7;
    width: 100%;
    border-radius: 5px;
    margin-bottom: 15px;
}

#nhMainPhone .phoneMain .phoneListCard .listCardText {
    /* border: 1px red solid; */
    padding: 10px 12px;
}

#nhMainPhone .phoneMain .phoneListCard .listCardBtn {
    border-top: 1px #f9f9f9 solid;
    padding: 10px;
    text-align: right;
    /* height: 40px; */
}

#nhMainPhone .phoneMain .phoneListCard .listCardText .el-descriptions-item__label {
    width: 75px;
    font-weight: bold;
    letter-spacing: 1px;
    display: inline-block;
    line-height: 30px;
    font-size: 15px;
}

#nhMainPhone .phoneMain .phoneListCard .listCardText .el-descriptions-item__content {
    /*css代码：*/
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /*行数*/
    -webkit-box-orient: vertical;
    line-height: 30px;
}

.topButton {
    position: absolute;
    top: 30px;
    right: 20px;
    z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// practiceManageMobile.vue?22a4d362